import React from 'react';
import { Grid } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import ChildrenType from '../../../../../../../../../../../../../../types/ChildrenType';

const Row = ({ children, sticky = false, ...rest }) => (
  <Grid
    bg="inherit"
    gap={4}
    gridTemplateColumns="repeat(10, 1fr);"
    position={sticky ? 'sticky' : 'initial'}
    py={2}
    rowGap={4}
    top={sticky ? 0 : 'initial'}
    width="100%"
    zIndex={sticky ? 1 : 'initial'}
    {...rest}
  >
    {children}
  </Grid>
);

Row.propTypes = {
  children: ChildrenType,
  sticky: PropTypes.bool
};

export default Row;
